export enum MapConstants {
  ADD_ZOOMABLE_OBJECT = 'ADD_ZOOMABLE_OBJECT',
  SET_ZOOMABLE_OBJECTS = 'SET_ZOOMABLE_OBJECTS',
  REMOVE_ZOOMABLE_OBJECT = 'REMOVE_ZOOMABLE_OBJECT',
}
